import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PasswordInput } from '@beholos/holoscommon';
import { deleteUser } from '../../services/user.service';
import { logout } from '../../services/auth.service';
import SideBar from '../../components/global/SideBar';

export default function DeleteUser() {
  const [step, setStep] = useState(1); // 1 = info step, 2 = password step
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleDeleteAccount = async () => {
    setLoading(true);
    setError('');

    try {
      const success = await deleteUser(password);

      if (success) {
        // Log the user out and redirect to login
        await logout();
      } else {
        setError('Error al eliminar la cuenta. Por favor, verifica tu contraseña.');
      }
    } catch (error) {
      console.error('Error deleting account:', error);
      setError('Se ha producido un error al intentar eliminar la cuenta.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex h-[calc(100vh-80px)] w-screen overflow-hidden">
      <div className="hidden md:block md:w-80 lg:w-96 h-full overflow-y-auto">
        <SideBar />
      </div>

      <div className="flex-1 h-full overflow-y-auto bg-gray-200 py-15 px-6">
        <div className="bg-white p-6 rounded max-w-6xl mx-auto border border-gray-200 shadow-md">
          {step === 1 ? (
            // Step 1: Information and warning
            <>
              <h3 className="text-2xl font-bold uppercase mb-4">Borrar cuenta</h3>
              <h4 className="text-lg mb-4">¿Te gustaría borrar tu cuenta de Holos?</h4>
              <hr className="mb-4" />
              <h6 className="text-sm font-semibold mb-4">
                Eliminar tu cuenta es PERMANENTE e IRREVERSIBLE. No podrá acceder a esta cuenta en el futuro.
              </h6>

              <div className="mt-4 mb-2">
                <strong>Suscripción:</strong> Si tienes una suscripción será cancelada.
              </div>

              <div className="mt-3 mb-4">
                <strong>Clases:</strong> Si tienes alguna clase reservada se cancelarán automáticamente.
              </div>

              <div className="mt-8 flex flex-col sm:flex-row gap-4">
                <button
                  type="button"
                  className="btn bg-gray-500 text-white px-6 py-2 rounded hover:bg-gray-600 transition-colors cursor-pointer"
                  onClick={() => navigate('/mi-cuenta')}
                >
                  Cancelar
                </button>

                <button
                  type="button"
                  className="btn bg-red-600 text-white px-6 py-2 rounded hover:bg-red-700 transition-colors cursor-pointer"
                  onClick={() => setStep(2)}
                >
                  Continuar
                </button>
              </div>
            </>
          ) : (
            // Step 2: Password confirmation
            <>
              <h3 className="text-2xl font-bold uppercase mb-4">Confirmar eliminación</h3>
              <h2 className="text-xl font-bold mb-4">
                ¿Estás seguro de que deseas eliminar de forma permanente tu cuenta?
              </h2>
              <p className="mb-4">
                Esta cuenta ya no estará disponible y se eliminarán todos los datos asociados.
              </p>
              <p className="mb-6">
                Para eliminar su cuenta, ingrese su contraseña y haga clic en confirmar.
              </p>

              <div className="mb-6">
                <label className="block mb-2">
                  <strong>Contraseña</strong>
                </label>
                <PasswordInput
                  value={password}
                  onChange={setPassword}
                  className={error ? 'border-red-500' : ''}
                />
              </div>

              {error && (
                <div className="text-red-600 font-semibold mb-4">
                  {error}
                </div>
              )}

              <div className="flex flex-col sm:flex-row gap-4">
                <button
                  type="button"
                  className="btn bg-gray-500 text-white px-6 py-2 rounded hover:bg-gray-600 transition-colors cursor-pointer"
                  onClick={() => {
                    setStep(1);
                    setPassword('');
                    setError('');
                  }}
                  disabled={loading}
                >
                  Oops, regresa.
                </button>

                <button
                  type="button"
                  className="btn bg-red-600 text-white px-6 py-2 rounded hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
                  disabled={!password || loading}
                  onClick={handleDeleteAccount}
                >
                  {loading ? 'Eliminando...' : 'Borrar cuenta'}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}


